import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DynamicTablePreviewService } from './dynamic-table-preview.service';

@Component({
  selector: 'fcp-dynamic-table-preview',
  templateUrl: './dynamic-table-preview.component.html',
  styleUrls: ['./dynamic-table-preview.component.scss']
})
export class DynamicTablePreviewComponent {
  public data;
  public loaded: boolean;

  constructor(
    public route: ActivatedRoute,
    private service: DynamicTablePreviewService
  ) {
    this.route.paramMap.subscribe(res => {
      const url = res as any;
      if (url.params['id']) {
        this.service.getQuery(url.params['id']).subscribe(response => {
          this.data = this.mapDynamicTable(response);
          this.loaded = true;
        })
      }
    });
  }

  private mapDynamicTable(page: any) {
    let content = '';
    if (page.header && page.header !== null && page.header !== '') {
      content = page.header.replace(/tbody/g, 'thead').replace('</table>', '').replace(/td/g, 'td style="text-align: center"');
    } else {
      content = '<table>';
    }

    if (page.data && page.data.length > 0) {
      content = content + '<tbody>';
      page.data.map(item => {
        const data = JSON.parse(item.flatData.content);
        data.map(row => {
          content = content + '<tr>';
          Object.keys(row).map(key => {
            const value = row[key];
            // if (!isNaN(+this.clearForNumber(value))) {
            //   content = content + '<td style="text-align: right">' + value + '</td>';
            // } else {
              content = content + '<td style="text-align: center">' + value + '</td>';
            // }
          });
          content = content + '</tr>';
        });
      });
      content = content + '</tbody>';
    };
    content = content + '</table>';

    return {
      name: page.name,
      textAfter: page.textAfter,
      textBefore: page.textBefore,
      content
    };
  }
}
